import { ImportReport, SearchQuery, SearchResult, defineEndpoint } from '@itc/shared';
import { z } from 'zod';
import { Blueprint, BlueprintPage, BlueprintUuid, ImportInput, ListQuery, SyncResult } from './schemas.ts';

// The Blueprint Library's contracts (design §7.3, plan 4A). Every change takes an
// Idempotency-Key.

const ByUuid = z.object({ uuid: BlueprintUuid });

/** A page of blueprints by name, with the stats and chips' counts. */
export const listBlueprints = defineEndpoint({ method: 'GET', path: '/blueprints', permission: 'blueprints.view', query: ListQuery, response: BlueprintPage });

/** Marks a blueprint as owned by the org. Doing it twice changes nothing. */
export const markOwned = defineEndpoint({ method: 'PUT', path: '/blueprints/:uuid/owned', permission: 'blueprints.manage', params: ByUuid, response: Blueprint, idempotencyKey: 'required' });

/** Takes a blueprint off the org's list. Doing it twice changes nothing. */
export const unmarkOwned = defineEndpoint({ method: 'DELETE', path: '/blueprints/:uuid/owned', permission: 'blueprints.manage', params: ByUuid, response: Blueprint, idempotencyKey: 'required' });

/**
 * Syncs with the wiki now. A failure is an answer, not an error: it's recorded, and the
 * page says why. It's several units of work, so it takes no Idempotency-Key, and a repeat
 * changes nothing the first didn't. Five a minute, as each reads the whole wiki.
 */
export const syncCatalog = defineEndpoint({ method: 'POST', path: '/blueprints/sync', permission: 'blueprints.manage', rateLimit: { max: 5 }, response: SyncResult });

/** R5: one slice of `fc_blueprints`, from an export. A dry run says what it would do, and writes nothing. */
export const importOwned = defineEndpoint({ method: 'POST', path: '/blueprints/admin/import', permission: 'blueprints.admin', recentLogin: true, body: ImportInput, response: ImportReport, idempotencyKey: 'required' });

/** What global search finds: nothing without blueprints.view. */
export const searchBlueprints = defineEndpoint({ method: 'GET', path: '/blueprints/search', permission: 'authenticated', query: SearchQuery, response: SearchResult });
